"use client"

import {
  Carousel,
  CarouselContent,
  CarouselItem
} from "@/components/ui/carousel"
import { SketchFrame } from "@/components/ui/sketch-frame"
import {
  WalletIcon,
  UsersIcon,
  StarIcon,
  IconComponent
} from "@/src/shared/assets/icons"

import { statsCarouselTexts as t } from "./localization/texts"

const statSlides = [
  {
    key: "playersRegistered",
    text: t.playersRegistered,
    value: "100,000+",
    icon: UsersIcon
  },
  {
    key: "paidAmount",
    text: t.paidAmount,
    value: "100,000,000.00 L",
    icon: WalletIcon
  },
  { key: "rating", text: t.rating, value: "4.7/5", icon: StarIcon }
] as const

export function StatsCarousel() {
  return (
    <section aria-label={t.ariaLabel} className="xlg:hidden">
      <div className="flex flex-col gap-2">
        <Carousel className="w-full" opts={{ align: "start" }}>
          <CarouselContent className="gap-2.5">
            {statSlides.map(({ key, ...props }) => (
              <CarouselItem key={key} className="shrink-0 basis-auto">
                <SketchFrame
                  tone="stone"
                  className="inline-flex h-[51px] max-w-[180px] [--sketch-cap:12px]"
                  contentClassName="flex h-full min-w-0 items-center gap-2 pl-2.5 pr-3"
                >
                  <StatItem {...props} />
                </SketchFrame>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </section>
  )
}

type StatItemProps = {
  text: string
  value: string
  icon: IconComponent
}

function StatItem(props: StatItemProps) {
  const Icon = props.icon
  return (
    <>
      <Icon className="size-6 shrink-0" />
      <div className="flex min-w-0 max-w-full flex-col gap-0.5">
        <span className="truncate text-[10px] text-white/75">{props.text}</span>
        <span className="truncate text-sm font-medium">{props.value}</span>
      </div>
    </>
  )
}
